import React, { useState, useEffect, useRef } from "react";
import "./editAnnouncement.css";
import Sidebar from "../Sidebar";
import { useDispatch } from "react-redux";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom'
import { faqdetailAction, posteditfaqAction, deletefaqimgAction } from "../../actions/faqAction";
import { decode } from "base-64";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import Header from "../../component/loaderComponent/Header/Header";
import { notify } from '../../services/notification';
import { pincodelistAction } from "../../actions/pincodeAction";
import { Box, Text } from "rebass";
import { stateListAction } from "../../actions/notificationAction";

function EditFaqsAnnouncment() {

    const [states, setDataStates] = useState({
        faq_type: "",
        category: "",
        question: "",
        send_to_type: "",
        answer: "",
        heading: "",
        description: "",
        link: "",
        link2: "",
        link3: "",
        send_to: "",
        state: "",
        state1: "",
        state2: "",
    })
    const [textCount, setTextCount] = useState(0);
    const [selectedFile, setSelectedFile] = useState([]);
    const [attachment, setattachment] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams()
    const decodeid = decode(id)

    const [pincodeState, setPincodeState] = useState({
        pincode: '',
        pincode1: '',
        pincode2: '',
        entity_idse: '',
        entity_ids1: '',
        entity_ids2: '',
        pincode_error: '',
        pincode1_error: '',
        pincode2_error: '',
        showPincodeList: {
            pincode: false,
            pincode1: false,
            pincode2: false,
        },
    });

    const [pincodeList, setPincodeList] = useState([]);
    const [count, setCount] = useState(1);
    const [statelist, setStatelist] = useState([]);
    const fileInputRefs = useRef(null);

    useEffect(() => {
        stateListData();
    }, []);

    async function stateListData() {
        setIsLoading(true);
        var response = await dispatch(stateListAction());
        if (response == 200 || response != null) {
            setIsLoading(false);
            if (response.data.count % 10 == 0) {
                setCount(Math.floor(response.data.count / 10));
            } else {
                setCount(Math.floor(response.data.count / 10 + 1));
            }
            // setStatelist(response.data.results.data);
            setStatelist(response.data.data);
        }
    }

    const handleFileUpload = (event) => {
        const files = event.target.files;
        if (attachment.length === 0) {
            const maxFiles = 2;
            if (selectedFile.length <= maxFiles && files.length <= 3) {
                setSelectedFile([...selectedFile, ...files]);
            } else {
                notify.error(`You can only upload a maximum of 3 files.`);
            }
        }
        else if (attachment.length === 1) {
            const maxFiles = 1;
            if (selectedFile.length <= maxFiles && files.length <= 2) {
                setSelectedFile([...selectedFile, ...files]);
            } else {
                notify.error(`You can only upload a maximum of 3 files.`);
            }
        }
        else if (attachment.length === 2) {
            const maxFiles = 0;
            if (selectedFile.length <= maxFiles && files.length <= 1) {
                setSelectedFile([...selectedFile, ...files]);
            } else {
                notify.error(`You can only upload a maximum of 3 files.`);
            }
        }
        else if (attachment.length === 3) {
            notify.error(`You can only upload a maximum of 3 files.`);
        }

    }

    useEffect(() => {
        FaqDeatailsData();
    }, []);

    const handleDownload = (attachurl) => {
        const link = document.createElement("a");
        link.href = attachurl;
        link.download = "myfile.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    function handleFileRemove(index) {
        const newFiles = [...selectedFile];
        newFiles.splice(index, 1);
        setSelectedFile(newFiles);
    }

    async function FaqDeatailsData() {
        let response = await dispatch(faqdetailAction(decodeid));
        if (response == 200 || response != null) {
            setattachment(response.data.data.attachment)
            setTextCount((response.data.data.description).length)
            const entityData = response.data.data.entity || [];
            setDataStates({
                ...states,
                id: response.data,
                faq_type: response.data.data.faq_type,
                send_to_type: response.data.data.entity_type,
                heading: response.data.data.heading,
                description: response.data.data.description,
                link: response.data.data.link[0]?.url ? response.data.data.link[0]?.url : "",
                link2: response.data.data.link[1]?.url ? response.data.data.link[1]?.url : "",
                link3: response.data.data.link[2]?.url ? response.data.data.link[2]?.url : "",
                send_to: response.data.data.entity_type,
                ...(response.data.data.entity_type === "STATE"
                    ? {
                        state: entityData[0]?.id || '',
                        state1: entityData[1]?.id || '',
                        state2: entityData[2]?.id || '',
                    }
                    : {}),


            });
            setPincodeState({
                ...pincodeState,
                pincode: entityData[0]?.pincode || '',
                pincode1: entityData[1]?.pincode || '',
                pincode2: entityData[2]?.pincode || '',
                ...(response.data.data.entity_type === "PINCODE"
                    ? {
                        entity_idse: entityData[0]?.id || '',
                        entity_ids1: entityData[1]?.id || '',
                        entity_ids2: entityData[2]?.id || '',
                    }
                    : {}),

            });
        }
    }

    const handleChange = (evt) => {
        const value = evt.target.value;
        setDataStates({
            ...states,
            [evt.target.name]: value.replace(/^ +/gm, ''),
        });
        updateChars();
    };

    const updateFaq = async (event) => {
        let data = new FormData();
        if (selectedFile === "") {
            data.append('faq_type', states.faq_type);
            data.append('entity_type', states.send_to_type);
            data.append('heading', states.heading);
            data.append('description', states.description);

            if (states.link) data.append('link', states.link);
            if (states.link2) data.append('link', states.link2);
            if (states.link3) data.append('link', states.link3);

            if (states.send_to_type === 'STATE') {
                if (states.state) data.append('entity_ids', states.state);
                if (states.state1) data.append('entity_ids', states.state1);
                if (states.state2) data.append('entity_ids', states.state2);
            } else if (states.send_to_type === 'COUNTRY') {
                data.append('entity_ids', 1);
            } else if (states.send_to_type === 'PINCODE') {
                { pincodeState.entity_idse && data.append('entity_ids', pincodeState.entity_idse); }
                { pincodeState.entity_ids1 && data.append('entity_ids', pincodeState.entity_ids1); }
                { pincodeState.entity_ids2 && data.append('entity_ids', pincodeState.entity_ids2); }
            }
        } else {
            selectedFile.forEach((file, i) => {
                data.append(`attachment`, file);
            });
            data.append('faq_type', states.faq_type);
            data.append('entity_type', states.send_to_type);
            data.append('heading', states.heading);
            data.append('description', states.description);

            if (states.link) data.append('link', states.link);
            if (states.link2) data.append('link', states.link2);
            if (states.link3) data.append('link', states.link3);

            if (states.send_to_type === 'STATE') {
                if (states.state) data.append('entity_ids', states.state);
                if (states.state1) data.append('entity_ids', states.state1);
                if (states.state2) data.append('entity_ids', states.state2);
            } else if (states.send_to_type === 'COUNTRY') {
                data.append('entity_ids', 1);
            } else if (states.send_to_type === 'PINCODE') {
                { pincodeState.entity_idse && data.append('entity_ids', pincodeState.entity_idse); }
                { pincodeState.entity_ids1 && data.append('entity_ids', pincodeState.entity_ids1); }
                { pincodeState.entity_ids2 && data.append('entity_ids', pincodeState.entity_ids2); }
            }
        }
        setIsLoading(true)
        let response = await dispatch(posteditfaqAction(data, decodeid));
        if (response == 200 || response != null) {
            if (selectedIds.length > 0) {
                FaqImgDelete();
                setIsLoading(false)
                notify.success("Announcement has been updated")
                navigate('/faqannouncments')
                window.scroll(0, 0)
            }
            else {
                setIsLoading(false)
                notify.success("Announcement has been updated")
                navigate('/faqannouncments')
                window.scroll(0, 0)
            }

        }
    }


    const FaqImgDelete = async () => {
        setIsLoading(true);
        let response = await dispatch(deletefaqimgAction(selectedIds));
        if (response == 200 || response != null) {
            setIsLoading(false);
            notify.success("Attachment Delete Successfully");
            FaqDeatailsData();
        }
    };
    const handleChangeState = (evt) => {
        const state_id = evt.target.value;
        setDataStates({
            ...states,
            [evt.target.name]: state_id,
        });
    };
    function updateChars() {
        const text = document.getElementById("text").value;
        setTextCount(text.length);
    }
    const oncancel = () => {
        window.scroll(0, 0)
        navigate('/faqannouncments')
    }

    function imageremove(index, id) {
        const Files = [...attachment];
        Files.splice(index, 1);
        setattachment(Files);
        setSelectedIds((prevIds) => {
            if (prevIds.includes(id)) {
                // Remove the ID if it already exists
                return prevIds.filter((prevId) => prevId !== id);
            } else {
                // Add the ID if it doesn't exist
                return [...prevIds, id];
            }
        });
    }
    function handleFileRemove(index) {
        if (selectedFile.length == 1) {
            setSelectedFile([]);
            if (fileInputRefs.current) {
                fileInputRefs.current.value = null;
            }
        }
        const newFiles = [...selectedFile];
        newFiles.splice(index, 1);
        setSelectedFile(newFiles);
    }

    const pattern = /[1-9][0-9]{5}/;

    const handleChanges = async (e, field) => {
        const { value } = e.target;
        if (value.length === 0) {
            setPincodeState((prevState) => ({
                ...prevState,
                [field]: '',
                [`${field}_error`]: '',
            }));
        } else if (value.length > 6) {
            setPincodeState((prevState) => ({
                ...prevState,
                [field]: value,
                [`${field}_error`]: 'Invalid pincode',
            }));
        } else if (pattern.test(value)) {
            setPincodeState((prevState) => ({
                ...prevState,
                [field]: value,
                [`${field}_error`]: '',
            }));
        } else {
            setPincodeState((prevState) => ({
                ...prevState,
                [field]: value,
                [`${field}_error`]: 'Invalid pincode',
            }));
        }
        // Update entity_ids based on the field
        setPincodeState((prevState) => ({
            ...prevState,
            [`entity_ids${field.charAt(field.length - 1)}`]: e.target.id,
        }));

        if (value.length >= 3) {
            var response = await dispatch(pincodelistAction(value));
            setPincodeList(response.data.data);
        }
    };

    const togglePincodeList = (field, show) => {
        setPincodeState((prevState) => ({
            ...prevState,
            showPincodeList: {
                ...prevState.showPincodeList,
                [field]: show,
            },
        }));
    };

    return (
        <div className="Create_faq_Conatiner">
            <div className="Faq_Sidebar">
                <Sidebar />
            </div>

            <div className="Faq_Content">
                <Header title="Edit Announcement" />
                {isLoading ? <Loader /> :
                    <div className="faq-edits-announncments">
                        <div className="edit-announcement">
                            <div className="grid-ann">
                                <span className="sendinvitelabel">Heading<span style={{ color: "red" }}>*</span></span>
                                <input
                                    type="text"
                                    placeholder="Heading"
                                    name="heading"
                                    className="create-trainers-input"
                                    value={states.heading}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="grid-ann">
                                <span className="sendinvitelabel">Description<span style={{ color: "red" }}>*</span></span>
                                <textarea
                                    type="text"
                                    placeholder="Description"
                                    name="description"
                                    value={states.description}
                                    onChange={handleChange}
                                    rows={10}
                                    className="create-trainers-input"
                                    cols={50}
                                    id="text"
                                    maxLength={1000}
                                />
                                <p className='textcount_ann montserrat-font'>{textCount}/1000</p>
                            </div>
                            <div className="grid-ann">
                                <span className="sendinvitelabel"> Notify to<span style={{ color: "red" }}>*</span></span>
                                <select name="send_to_type" id="send_to_type" value={states.send_to_type} onChange={handleChange}>
                                    <option value=""> Select</option>
                                    <option value="PINCODE">Pincode</option>
                                    <option value="COUNTRY">All</option>
                                    <option value="STATE">State</option>
                                </select>
                            </div>
                            {states.send_to_type === "STATE" ? (
                                <div>
                                    <div className="grid-ann-input">
                                        <span className="sendinvitelabel"></span>
                                        <select
                                            name="state"
                                            value={states.state}
                                            onChange={handleChangeState}
                                        >
                                            <option value="0">Select State</option>
                                            {statelist?.map((item) => (
                                                <option value={item?.id}>{item?.state}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="grid-ann-input">
                                        <span className="sendinvitelabel"></span>
                                        <select
                                            name="state1"
                                            value={states.state1}
                                            onChange={handleChangeState}
                                        >
                                            <option value="0">Select State</option>
                                            {statelist.map((item) => (
                                                <option value={item.id}>{item.state}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="grid-ann-input">
                                        <span className="sendinvitelabel"></span>
                                        <select
                                            name="state2"
                                            value={states.state2}
                                            onChange={handleChangeState}
                                        >
                                            <option value="0">Select State</option>
                                            {statelist.map((item) => (
                                                <option value={item.id}>{item.state}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            ) : ""}
                            {states.send_to_type === "PINCODE" ? (
                                <div>
                                    {['pincode', 'pincode1', 'pincode2'].map((field, index) => (
                                        <>
                                            <div key={field} className="grid-ann-input">
                                                <span className="sendinvitelabel"></span>
                                                <input
                                                    type="text"
                                                    className="input-create-trainings"
                                                    maxLength={6}
                                                    name={field}
                                                    value={pincodeState[field]}
                                                    onChange={(e) => handleChanges(e, field)}
                                                    onFocus={() => togglePincodeList(field, true)}
                                                />
                                                <div className={`error_msg pincode_errorMsg-create-announcment ${pincodeState[`${field}_error`] ? 'show' : ''}`}>
                                                    {pincodeState[`${field}_error`]}
                                                </div>
                                            </div>
                                            <div key={field} className="grid-ann-box">
                                                <span className="sendinvitelabel"></span>
                                                {pincodeState[field].length >= 3 && pincodeState.showPincodeList[field] ? (
                                                    <Box className="search-child" key={field}>
                                                        {pincodeList.length > 0 &&
                                                            pincodeList.map((item, i) => (
                                                                <Text
                                                                    key={i}
                                                                    className="search-childText"
                                                                    onClick={() => handleChanges({ target: { value: item.pincode, id: item.id } }, field, togglePincodeList(field, false))}
                                                                >
                                                                    {item.pincode}
                                                                </Text>
                                                            ))}
                                                    </Box>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        </>
                                    ))}


                                </div>
                            ) : (
                                ""
                            )}
                            <div >
                                <div className="grid-ann">

                                    <span className="sendinvitelabel">Link </span>
                                    <input
                                        type="text"
                                        placeholder="Link"
                                        name="link"
                                        value={states.link}
                                        className="create-trainers-input"
                                        onChange={handleChange}
                                    />

                                </div>
                                <div>
                                    <div className="grid-ann">
                                        <span className="sendinvitelabel">Link-2</span>
                                        <input
                                            type="url"
                                            placeholder="Link-2"
                                            name="link2"
                                            className="create-trainers-input"
                                            value={states.link2}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className="grid-ann">
                                        <span className="sendinvitelabel">Link-3</span>
                                        <input
                                            type="url"
                                            placeholder="Link-3"
                                            name="link3"
                                            value={states.link3}
                                            className="create-trainers-input"
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className="grid-ann">
                                        <span className="sendinvitelabel">Attachment</span>
                                        <label htmlFor="formId" className="upload-box-edits-annoucmentss">
                                            <input name="" type="file" id="formId" ref={fileInputRefs} onChange={handleFileUpload} hidden accept="image/png,image/jpg,image/jpeg,.pdf"
                                                multiple />
                                            Choose Files
                                        </label>
                                    </div>
                                </div>
                                <ul className="">
                                    {attachment.map((file, ind) => (
                                        <>
                                            <li className="file_nameAttach" key={ind} >
                                                {file.attachment?.endsWith('.jpg') || file.attachment?.endsWith('.png') || file.attachment?.endsWith('.jpeg') || file.attachment?.endsWith('.webp') ?
                                                    <span >
                                                        <img
                                                            src={file.attachment}
                                                            key={ind}
                                                            alt="preview"
                                                            height="100px"
                                                            width="100px"
                                                        />
                                                    </span>
                                                    : <>
                                                        {file.attachment.substring(file.attachment.lastIndexOf("/") + 1)}
                                                    </>}
                                                <img
                                                    alt="Delete_icons"
                                                    className="cursor-pointer Delete_icons"
                                                    src={Image_Url.DELETE_ICONS}
                                                    onClick={() => imageremove(ind, file.id)}
                                                />
                                            </li>
                                            {file.attachment !== "" ?
                                                <div className="">
                                                    <span className="download_editbtn " onClick={() => { handleDownload(file.attachment); }} >
                                                        Download</span>
                                                </div>
                                                : ""}
                                        </>
                                    ))}

                                    {selectedFile.map((data, i) =>
                                        <li className="file_nameAttach" key={i}>
                                            <span>{data.name} <img
                                                alt="Delete_icons"
                                                className="cursor-pointer Delete_icons"
                                                src={Image_Url.DELETE_ICONS}
                                                onClick={() => handleFileRemove(i)} />
                                            </span>
                                        </li>

                                    )}
                                </ul>
                            </div>
                            <div className="createfaqbutton">
                                <button className="createfaq_buttonAll" onClick={oncancel}>Close</button>
                                {states.send_to_type === "COUNTRY" ?
                                    <button
                                        className="updatefaq_buttonAll"
                                        disabled={
                                            states.heading === "" ||
                                            states.description === "" ||
                                            states.send_to_type === ""
                                        }
                                        onClick={updateFaq}
                                    >
                                        Update
                                    </button>
                                    :
                                    <button
                                        className="updatefaq_buttonAll"
                                        disabled={
                                            states.heading === "" ||
                                            states.description === "" ||
                                            states.send_to_type === ""
                                        }
                                        onClick={updateFaq}
                                    >
                                        Update
                                    </button>}

                            </div>
                        </div>
                    </div>
                }
            </div>

        </div>
    );
}
export default EditFaqsAnnouncment;
